module.exports = __webpack_public_path__ + "img/33.a0883f53.png";